// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-content > button[data-v-66c64796] {\n  border: none;\n  font-size: 14px;\n  padding-right: 2rem;\n}", ""]);
// Exports
module.exports = exports;
